import { render, staticRenderFns } from "./stickers.vue?vue&type=template&id=08bd0ee9"
import script from "./stickers.vue?vue&type=script&lang=js"
export * from "./stickers.vue?vue&type=script&lang=js"
import style0 from "./stickers.vue?vue&type=style&index=0&id=08bd0ee9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports